import axios from 'axios';

import api from '../../lib/api';

export const getArticles = (pathway, catId, favourites, name, pageNumber) =>
  function get(dispatch) {
    const favouriteStr = (favourites ? `&favourites=${favourites.join(',')}` : '');
    const limit = (window.innerWidth < 630 ? 3 : 6);
    const nameStr = `&name=${name}`;
    const pageStr = `&page=${pageNumber}`;
    axios
      .get(`/json/dashboard.json?limit=${limit}&action=articles&pathway=${pathway}&catId=${catId}${favouriteStr}${nameStr}${pageStr}`)
      .then(response => dispatch(getArticlesSuccess(response.data)))
      .catch(error => console.error(error));
  };

export const updateFavourite = articleId =>
  function get(dispatch) {
    api
      .sendPost('/public-dashboard/favourite/article', { article_id: articleId }, (error, response) => {
        if (error) return console.error(error);
        return dispatch(getFavourites());
      });
  };

export const getFavourites = () =>
  function get(dispatch) {
    api
      .sendGet('/public-dashboard/favourite/article', (error, response) => {
        if (error) return console.error(error);
        return dispatch(getFavouritesSuccess(response.data));
      });
  };

export const getArticlesSuccess = data => ({
  type: 'GET_ARTICLES_SUCCESS',
  data,
});

export const getFavouritesSuccess = data => ({
  type: 'GET_ARTICLES_FAVOURITES_SUCCESS',
  data,
});



// WEBPACK FOOTER //
// ./src/Actions/Dashboard/articles.js